import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={545.261}
      height={392.869}
      viewBox="0 0 545.261 392.869"
      {...props}
    >
      <g data-name="Group 674">
        <g data-name="Group 475">
          <path
            data-name="Path 9220"
            d="M20.493 304.879a36.735 36.735 0 001.5-12.666c-1.236-18.968-16.484-33.462-20.3-51.787-3.707-17.868-1.446-38.108 12.74-50.972 19.61-17.769 50.44-15.829 64.4-40.926 12.505-22.477 9.774-49.662 23.4-72.151 12.839-21.142 33.388-35.588 55-46.709C188.533 13.469 224.874-.482 260.486.01c40.456.581 69.321 28.062 96.383 54.753 23.849 23.478 65.849 21.365 53.616 82.074-10.911 54.061 14.828 50.045 38.368 70.014s40.716 43.681 31.362 70.644c-10.306 29.755 52.838 46.82 64.095 85.361 7.649 26.147-32.474 28.359-59.782 28.359s-260.926-2.224-359.731.877c-27.247.853-53.381 1.718-80.492-1.606-11.5-1.421-23.243-4.4-32.288-11.64-28.336-22.662 1.395-49.55 8.476-73.967z"
            fill="rgba(207,30,34,0.31)"
            opacity={0.35}
          />
        </g>
        <g data-name="Layer 2">
          <g data-name="Layer 1">
            <path
              data-name="Path 9480"
              d="M335.891 222.435l.29 2.88c0-.16 7.38-.38 7.38-.38v-2.9s-7.68.23-7.67.4z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9481"
              d="M324.571 224.685l.93 2.75 1.09-.33a18.005 18.005 0 012.42-.65l3.59-.72-.46-2.86-3.81.77a19.517 19.517 0 00-2.59.69z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9482"
              d="M314.141 229.765l1.68 2.38c-.14-.24 6.26-3.68 6.35-3.48l-1.18-2.65c-.1-.2-7 3.5-6.85 3.75z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9483"
              d="M305.831 237.865l2.29 1.79a22.232 22.232 0 012.31-2.79 20.942 20.942 0 012.59-2.54l-1.89-2.2a23.42 23.42 0 00-2.8 2.73 26.276 26.276 0 00-2.5 3.01z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9484"
              d="M300.041 247.865l2.63 1.2s.76-1.69 1.63-3.32c.44-.79.88-1.6 1.2-2.19l.61-1-2.43-1.56-.66 1-1.28 2.34c-.92 1.78-1.7 3.53-1.7 3.53z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9485"
              d="M296.031 257.955l2.37 1.85 1.36-3.65c.72-1.82 1.43-3.64 1.43-3.64l-2.58-1.33-1.35 3.42c-.6 1.65-1.23 3.35-1.23 3.35z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9486"
              d="M292.091 268.005l2 2.53s.82-1.74 1.54-3.54 1.43-3.61 1.43-3.61l-2.26-2.1-1.3 3.38c-.65 1.69-1.41 3.34-1.41 3.34z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9487"
              d="M286.631 277.275l1.48 3a6.362 6.362 0 00.76-.92l1.56-2.15c.51-.81 1-1.64 1.4-2.25a7.548 7.548 0 00.57-1l-1.84-2.73s-.85 1.59-1.8 3.14c-.52.75-1.05 1.48-1.43 2a6.351 6.351 0 01-.7.91z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9488"
              d="M278.171 283.815l.85 3.37 1.09-.54a13.681 13.681 0 002.3-1.31 20 20 0 003.07-2.33l-1.3-3.17a18.88 18.88 0 01-2.85 2.23 12 12 0 01-2.15 1.24z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9489"
              d="M267.711 286.215l.15 3.49s1.92-.19 3.84-.4l2.6-.55a9.828 9.828 0 001.18-.28l-.63-3.43a10.186 10.186 0 01-1.1.27l-2.44.52z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9490"
              d="M256.961 285.605l-.58 3.45s.47.11 1.19.25l2.65.23 2.64.21h1.21l.1-3.49h-1.14l-2.48-.2-2.48-.22z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9491"
              d="M247.261 281.185l-1.25 3.22a27.131 27.131 0 003.21 2.13 13 13 0 002.39 1.13l1.12.46.81-3.4-1.05-.43a12.089 12.089 0 01-2.24-1.07 27 27 0 01-2.99-2.04z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9492"
              d="M240.261 273.015l-1.82 2.79 2.2 3.17c1.26 1.46 2.53 2.91 2.53 2.91l1.45-3.1-2.34-2.77c-1.02-1.5-2.02-3-2.02-3z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9493"
              d="M235.501 263.355l-2.24 2.25s.75 1.78 1.57 3.54a32.494 32.494 0 001.75 3.45l2-2.61a30.179 30.179 0 01-1.6-3.26c-.78-1.7-1.48-3.37-1.48-3.37z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9494"
              d="M232.061 253.125l-2.59 1.48s.54 1.88 1.16 3.72 1.25 3.69 1.25 3.69l2.38-2s-.61-1.71-1.14-3.45-1.06-3.44-1.06-3.44z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9495"
              d="M229.421 242.605l-2.82.7.9 3.78c.44 1.91.95 3.79.95 3.79l2.68-1.21s-.47-1.75-.88-3.52-.83-3.54-.83-3.54z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9496"
              d="M227.211 231.735l-2.85.52 1.46 7.44 2.84-.61z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9497"
              d="M225.291 220.695l-2.85.47 1.27 7.45 2.85-.51z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9498"
              d="M223.531 209.615l-2.86.46 1.18 7.45 2.85-.47z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9499"
              d="M221.791 198.515l-2.86.46 1.17 7.44 2.86-.44z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9500"
              d="M219.931 187.425l-2.84.51 1.25 7.41 2.85-.47z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9501"
              d="M217.811 176.355l-2.82.58s.37 1.84.75 3.68.68 3.69.68 3.69l2.86-.53s-.34-1.85-.69-3.71z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9502"
              d="M215.261 165.335l-2.8.76s.47 1.81.93 3.61.85 3.65.85 3.65l2.82-.63s-.42-1.85-.86-3.7z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9503"
              d="M211.841 154.505l-2.71 1s.66 1.73 1.24 3.5 1.1 3.56 1.1 3.56l2.77-.81s-.55-1.83-1.12-3.65-1.28-3.6-1.28-3.6z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9504"
              d="M207.011 144.035l-2.45 1.57 1.72 3.21c.82 1.63 1.51 3.34 1.51 3.35l2.67-1.15s-.72-1.77-1.6-3.51z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9505"
              d="M199.511 135.205l-1.91 2.19.87.74a13.81 13.81 0 011.81 1.7l1.62 1.9a5 5 0 01.7.9l2.29-1.79a5.67 5.67 0 00-.75-1l-1.75-2a16 16 0 00-2-1.83z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9506"
              d="M189.771 128.975l-1.34 2.56a7 7 0 011 .54l2.18 1.28a29.442 29.442 0 013.08 2l1.69-2.37a36.768 36.768 0 00-3.28-2.09l-2.28-1.34a7.889 7.889 0 00-1.05-.58z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9507"
              d="M178.991 124.785l-.67 2.82 3.49 1 3.4 1.33 1.16-2.64-3.63-1.43z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9508"
              d="M167.261 124.215l.44 2.86 1.1-.18c.66-.07 1.56-.07 2.44-.11a32.119 32.119 0 013.58.19l.36-2.87a37.441 37.441 0 00-4-.22 26.451 26.451 0 00-2.73.14z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9509"
              d="M156.321 128.485l1.61 2.42.92-.63 2.16-1.16c.81-.38 1.65-.67 2.26-.94a10.311 10.311 0 011-.35l-.84-2.76a5.25 5.25 0 00-1.19.39c-.69.29-1.63.62-2.53 1.05l-2.41 1.3z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9510"
              d="M147.891 136.545l2.29 1.76.69-.9 1.65-1.89c1.25-1.3 2.6-2.5 2.6-2.5l-1.86-2.19s-1.49 1.31-2.84 2.72l-1.77 2z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9511"
              d="M141.981 146.445l2.62 1.21a58.8 58.8 0 013.52-6.43l-2.42-1.57s-1 1.65-2 3.33a28.922 28.922 0 00-1.72 3.46z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9512"
              d="M138.071 157.225l2.79.75s.5-1.78 1.06-3.53 1.27-3.47 1.27-3.47l-2.7-1.06s-.7 1.79-1.32 3.62-1.1 3.69-1.1 3.69z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9513"
              d="M136.021 168.545l2.89.2s.14-1.81.43-3.63.67-3.62.67-3.62l-2.83-.61s-.41 1.89-.7 3.79-.46 3.87-.46 3.87z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9514"
              d="M136.651 179.985l2.88-.3-.53-5c-.1-.8-.15-1.63-.19-2.44l-2.89.08a21.163 21.163 0 00.2 2.63z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9515"
              d="M137.591 191.115l2.89-.19-.6-7.55-2.88.26z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9516"
              d="M138.151 202.275l2.89-.08s-.06-1.9-.13-3.79-.19-3.79-.19-3.79l-2.9.17.2 3.75c.06 1.87.13 3.74.13 3.74z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9517"
              d="M138.261 213.435h2.89v-7.59h-2.89v7.59z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9518"
              d="M137.731 224.605l2.88.22s.11-1.9.23-3.8.18-3.79.18-3.79l-2.9-.1s0 1.87-.16 3.73-.23 3.74-.23 3.74z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9519"
              d="M136.481 235.605l2.86.44s.26-1.89.51-3.77.42-3.79.42-3.79l-2.88-.29s-.15 1.87-.42 3.71-.49 3.7-.49 3.7z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9520"
              d="M134.261 246.455l2.8.72s.5-1.85.88-3.71.76-3.75.76-3.75l-2.84-.52s-.32 1.84-.75 3.64-.85 3.62-.85 3.62z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9521"
              d="M130.791 256.885l2.67 1.12a32.332 32.332 0 001.39-3.58c.63-1.81 1.22-3.64 1.22-3.64l-2.76-.84-1.18 3.5a32.35 32.35 0 01-1.34 3.44z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9522"
              d="M125.631 266.425l2.33 1.74s1.1-1.63 2.12-3.28l1.83-3.43-2.59-1.29-1.71 3.22z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9523"
              d="M118.321 274.295l1.74 2.31c.18.21 5.73-5.3 5.57-5.45l-2.16-1.94c.15.15-4.99 5.28-5.15 5.08z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9524"
              d="M108.861 279.375l1 2.73 1.16-.41a14 14 0 002.48-1l3.45-1.81-1.52-2.5-3.17 1.66a12.241 12.241 0 01-2.3.95c-.7.24-1.1.38-1.1.38z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9525"
              d="M98.261 281.275l.19 2.89 3.89-.29a38.2 38.2 0 003.84-.73l-.75-2.8s-1.76.42-3.56.66z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9526"
              d="M87.461 280.485l-.47 2.85 3.8.58c1.93.17 3.88.22 3.88.22l.07-2.9s-1.82 0-3.64-.19z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9527"
              d="M76.761 277.885l-.86 2.72c-.06.18 7.39 2 7.39 2l.62-2.83s-7.19-1.71-7.15-1.89z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9528"
              d="M66.391 274.005l-1.13 2.67 3.51 1.46a21.945 21.945 0 002.46.93l1.13.38 1-2.73-1.1-.37a20.631 20.631 0 01-2.39-.9z"
              fill="#fbe366"
            />
            <path
              data-name="Path 9529"
              d="M350.331 284.205a20.35 20.35 0 11-5.332-14.682 20.4 20.4 0 015.332 14.682z"
              fill="#cbe9f4"
            />
            <path
              data-name="Path 9530"
              d="M400.891 271.985a27.6 27.6 0 01-8.54-23.68c.79-5.15 15.28-14.12 15.28-14.12l-21.61-23.49s-10.14 13.75-15.33 14.1a25.86 25.86 0 01-21.73-10.12c-3.07-4.21.9-20.79.9-20.79l-31.93-1.37s2.5 16.87-.89 20.79a22.18 22.18 0 01-20 6.79c-5.11-1-13.38-15.92-13.38-15.92l-24.4 20.55s13.24 10.72 13.37 15.91a29.3 29.3 0 01-11.73 23.55c-4.25 3-20.81-1.15-20.81-1.15l-1.83 31.9s16.87-2.31 20.73 1.14a27.66 27.66 0 018.56 23.69c-.79 5.15-15.3 14.11-15.3 14.11l21.61 23.49s10.18-13.76 15.4-14.09a26.05 26.05 0 0121.74 10.11c3.06 4.23-.88 20.79-.88 20.79l31.89 1.43s-2.53-16.87.87-20.79a22.26 22.26 0 0120-6.79c5.09 1 13.36 15.92 13.36 15.92l24.45-20.55s-13.23-10.79-13.38-15.97a29.42 29.42 0 0111.73-23.55c4.25-3 20.82 1.18 20.82 1.18l1.77-31.9s-16.85 2.29-20.74-1.17zm-73.18 64.19a52.91 52.91 0 1155.13-50.57 52.91 52.91 0 01-55.13 50.57z"
              fill="#18206b"
            />
            <path
              data-name="Path 9531"
              d="M370.381 285.775a40.41 40.41 0 11-10.58-29.1 40.43 40.43 0 0110.58 29.1z"
              fill="#142b6f"
            />
            <path
              data-name="Path 9532"
              d="M270.131 140.335c.34-2.5-1.19-9.88-8-12-9.13-2.83-28.28.88-37.22-8.83s-6.24-18.25-5.19-24.18 4.3-7.8 4.53-11.32-3.95-3.63-8 5.48c-1.92 4.35-13.94 24.72-5.43 38.28 11.16 17.75 57.19 27.34 59.31 12.57z"
              fill="#fbc6b4"
            />
            <path
              data-name="Path 9533"
              d="M271.931 135.695s.59 10.47-15 11.78-22.5-.27-22.5-.27-3.81-9.46.81-24.79c.02 0 38.02-1.56 36.69 13.28z"
              fill="#eda503"
            />
            <path
              data-name="Path 9534"
              d="M297.361 128.365v-.05c-5.24-2.84-12-3.48-17.11-4-11.34-1.19-29.87.39-33.41 20.26-1.15 6.55-1.49 16.13-.89 25.92.09 2.12.22 4.3.5 6.43.9 9.55-2 16 1.43 20.84 9.89 14.15 67.2 26.12 58 8.52-.19-.4-2.24-6.22 1.88-8-2.9-8.14-2.59-17.87-3.93-24.63a53.534 53.534 0 01-.8-6.15 52.29 52.29 0 011.33-15.9c3.11-13.31-.89-19.81-7-23.24z"
              fill="#ffb502"
            />
            <path
              data-name="Path 9535"
              d="M224.911 263.875c11 11.69 29 24.74 35.15 33.7 1 1.42 1.1 2.08-2.92 6.19s2.16 4.34 10.41-.37-18.49-42.15-33-58.62c-12.62-14.41-22.46 5.53-9.64 19.1z"
              fill="#fbc6b4"
            />
            <path
              data-name="Path 9536"
              d="M268.911 297.425s-5.57 7.11-11.77 6.34c0 0-7.57 5.65-1.23 5.06s17.35-4.11 13-11.4z"
              fill="#ffb502"
            />
            <path
              data-name="Path 9537"
              d="M289.411 142.275c-2 9.87-6.91 25.06 15.78 37.09 0 0-39.2 47.38-62.65 23.12 0 0 3.11-42.84 8.85-60 1.65-4.93 5.56-18.46 16.27-17.91 0 0-16 24.25-8.83 30.36s13.56.55 16.46-4.33c4.67-7.84 15-24.82 15-24.82l6.28 2.16a33.15 33.15 0 00-7.16 14.33z"
              fill="#1c2745"
            />
            <path
              data-name="Path 9538"
              d="M289.081 110.165s-6.38 7-2 13.11c4.51 6.33-22.22 11.33-20.15 6.74 2.64-5.94 6.94-8.6 6.14-16.63z"
              fill="#f7b2a0"
            />
            <path
              data-name="Path 9539"
              d="M280.911 90.605c-6.8 3.3-19.21 23.27-15.21 29.78 1.77 2.83 12.38 3.56 21.6-4 3.8-3.1 9.27-9.47 7.61-18.09-.75-3.96-6.11-11.54-14-7.69z"
              fill="#fbc6b4"
            />
            <path
              data-name="Path 9540"
              d="M274.741 91.605c-2 2.37-1.87 3.1 6 6.91s9.4 3.7 7.95 5.39c-4.25 5 2 5.69-3.19 11.6s3.05 3.92 7.83-.75c.94-.95 6.12-5.38 4.79-15.14-1.59-11.46-15.96-16.73-23.38-8.01z"
              fill="#1d1b3a"
            />
            <path
              data-name="Path 9541"
              d="M283.561 106.225s-18.89-9-16.3-16.73c1.6-4.76 16.05-.22 16.05-.22z"
              fill="#eda503"
            />
            <path
              data-name="Path 9542"
              d="M273.731 92.605c.68 8 5.62 12.57 21.71 20 0 0 11.13-13.67 1.59-23.62-8.43-8.76-23.77-1.54-23.3 3.62z"
              fill="#ffb502"
            />
            <path
              data-name="Path 9543"
              d="M248.131 192.995s-46.44 15.61-54.22 29.11 60.46 75.12 60.46 75.12 10.91-7.2 8.4-16.3c-9.41-34.13-13.14-45.21-13.14-45.21l45-24.22z"
              fill="#1c2745"
            />
            <path
              data-name="Path 9544"
              d="M269.001 289.495c1.69 16 8.08 37.28 7.51 48.1-.09 1.73-.38 2.34-6.08 3.17s-.91 4.75 8.51 6 10.86-44.73 9.34-66.62c-1.33-19.1-21.24-9.21-19.28 9.35z"
              fill="#fbc6b4"
            />
            <path
              data-name="Path 9545"
              d="M283.651 342.865s-8.76 2.27-13.22-2.1c0 0-9.44-.1-4 3.27s16.22 7.23 17.22-1.17z"
              fill="#ffb502"
            />
            <path
              data-name="Path 9546"
              d="M305.191 179.365a203.16 203.16 0 015.17 45.41c.16 31.54-20.72 104.67-20.72 104.67s.83 2.65-17.22-3.44c-4.86-1.65-7.29-107.53-7.29-107.53l11.92-27.07z"
              fill="#1c2745"
            />
            <path
              data-name="Path 9547"
              d="M283.431 329.345l-1-.36c18.32-50.17 14.25-134.88 14.21-135.73l1.05-.06c.05.85 4.13 85.78-14.26 136.15z"
              fill="#fff"
            />
            <path
              data-name="Path 9548"
              d="M310.931 381.085l-69.08-170.29h-39.93l68.44 168.71-3.89 1.58-70.78-174.49h48.99l70.15 172.91z"
              fill="#464f72"
            />
            <path
              data-name="Rectangle 1288"
              fill="#464f72"
              d="M229.591 282.485h44.46v4.2h-44.46z"
            />
            <path
              data-name="Rectangle 1289"
              fill="#464f72"
              d="M238.491 303.325h44.46v4.2h-44.46z"
            />
            <path
              data-name="Rectangle 1290"
              fill="#464f72"
              d="M246.191 324.365h44.46v4.2h-44.46z"
            />
            <path
              data-name="Rectangle 1291"
              fill="#464f72"
              d="M255.841 345.825h44.46v4.2h-44.46z"
            />
            <path
              data-name="Rectangle 1292"
              fill="#464f72"
              d="M170.487 379.564l46.111-122.873 3.933 1.476-46.112 122.873z"
            />
            <path
              data-name="Rectangle 1293"
              fill="#464f72"
              d="M217.505 381.94l45.946-123.356 3.947 1.47-45.945 123.356z"
            />
            <path
              data-name="Path 9549"
              d="M234.091 109.705a14.38 14.38 0 11-4.212-10.178 14.39 14.39 0 014.212 10.178z"
              fill="#ffcf03"
            />
            <path
              data-name="Rectangle 1294"
              fill="#464f72"
              d="M216.981 40.605h5.43v38.53h-5.43z"
            />
            <path
              data-name="Rectangle 1295"
              fill="#6d76a1"
              d="M213.031 70.245h13.34v17.78h-13.34z"
            />
            <path
              data-name="Path 9550"
              d="M219.701 78.605a33.35 33.35 0 00-33.35 33.35h66.69a33.35 33.35 0 00-33.34-33.35z"
              fill="#cf1e22"
            />
            <path
              data-name="Path 9551"
              d="M304.171 137.305c-.49-2.37-3.72-7-10.53-6.67-9.12.41-25.09 10-36.25 4.15s-11.53-14.33-12.51-20 1.3-8.38.38-11.61-4.74-2-5.37 7.49c-.29 4.53-4.46 26.71 7.57 36.1 15.8 12.32 59.61 4.46 56.71-9.46z"
              fill="#fbc6b4"
            />
            <path
              data-name="Path 9552"
              d="M304.201 134.985s3.93 9.21-9.61 15.43-20.25 7.08-20.25 7.08-6.49-7.27-7.33-22.51c0 0 33.51-13.73 37.19 0z"
              fill="#eda503"
            />
            <path
              data-name="Path 9553"
              d="M175.261 178.605a8.87 8.87 0 118.86-8.87 8.87 8.87 0 01-8.86 8.87zm0-13.78a4.93 4.93 0 100-.01z"
              fill="#64b4d7"
            />
            <path
              data-name="Rectangle 1296"
              fill="#27355c"
              d="M120.531 318.825h36.36v2.81h-36.36z"
            />
            <path
              data-name="Rectangle 1297"
              fill="#27355c"
              d="M134.731 309.645h20.04v2.81h-20.04z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
